$(document).on('click', '.js-toggle-btn', function(e) {
	e.preventDefault();
	const $this = $(this);
	const btnId = $this.data('href');
	const btnClass = $this.data('class');

	$(btnId).toggleClass(btnClass);
});

$(document).on('click', '.js-search', function(e) {
	e.preventDefault();
	setTimeout(function() {
		$('#search-bar .search__field').focus();
	}, 400);
});
